<template>
  <div class="flex justify-end space-x-1 flex-wrap">
    <div
      v-if="status"
      class="text-white p-1 text-2xs leading-none rounded-sm inline-block m-px"
      :style="{
        backgroundColor: '#' + status.colour + 'e6'
      }"
    >
      {{ status.label }}
    </div>
    <div
      v-if="pass"
      class="text-white p-1 text-2xs leading-none rounded-sm inline-block bg-green-600 m-px"
    >
      {{ $t('general.pass') }}
    </div>
    <div
      v-if="resource"
      class="text-white p-1 text-2xs leading-none rounded-sm inline-block bg-gray-700 m-px"
    >
      {{ resource.name }}
    </div>
    <div
      v-if="checkedIn"
      class="text-white p-1 text-2xs leading-none rounded-sm inline-block bg-blue-600 m-px"
    >
      {{ $t('schedule.checkedIn') }}
    </div>
    <div
      v-if="isPaid && !pass"
      class="text-white p-1 text-2xs leading-none rounded-sm inline-block bg-green-600 m-px"
    >
      {{ $t('general.paid') }}
    </div>
    <div
      v-if="hasBouncedEmail"
      class="text-white p-1 text-2xs leading-none rounded-sm inline-block bg-yellow-500 m-px"
    >
      {{ $t('general.bounced') }}
    </div>

    <customer-alerts v-if="customer" :customer="customer">
      <div class="text-white p-1 text-2xs leading-none rounded-sm inline-block bg-red-500 m-px">
        <o-icon icon="warning" :size="12" />
      </div>
    </customer-alerts>
  </div>
</template>

<script setup lang="ts">
import CustomerAlerts from '@/components/customer/elements/Alerts.vue'

interface Props {
  resource?: any
  pass?: any
  status?: any
  checkedIn?: boolean
  isPaid?: boolean
  hasBouncedEmail?: boolean
  customer?: any
}

withDefaults(defineProps<Props>(), {
  resource: null,
  pass: null,
  status: null,
  checkedIn: false,
  isPaid: false,
  hasBouncedEmail: false,
  customer: null,
})
</script>
